export default __webpack_public_path__ + "static/media/42.2fe2c4f7.png";